import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';

import { connect } from 'react-redux';
import { Dispatch } from "redux";

import { useParams } from "react-router-dom"; 

import GenericPageComponent from '../GenericPageComponent/GenericPageComponent'
//import GenericTableOfContent from '../GenericTableOfContent/GenericTableOfContent'
import GenericFlowOverview from '../GenericFlowOverview/GenericFlowOverview'

import { RootState } from '../../store/Store';
import { FlowState, updateFlowInputAction } from '../../store/reducers/FlowReducer'

import { setFlowTarget } from '../../service/flowengine/FlowEngineAPI';
//import { Page } from "../../service/flowengine/model/Page"

//import UploadFilesDragAndDrop from "../UploadFilesDragAndDrop/UploadFilesDragAndDrop"

//import { getPageByIndex } from '../../service/flowengine/FlowEngineAPI';
//import { Page } from "../../service/flowengine/model/Page"



// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------

type Props = {
    pagename?: string;
    target?: string;
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    flow: any
}

type PropsHandler = {
    updateFlowInput(state: FlowState): any,
}


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    flow: state.flow.flow,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateFlowInput: (state: FlowState) => dispatch(updateFlowInputAction(state)),
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type FlowEngineProps = Props & PropsStatic & PropsHandler;


// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//

// stateless component resp. functional component

interface ParamTypes {
  page: string
}

// ---------------------------------------------------
//var pageToDisplay:  Page | undefined = getPageByIndex(0);

////let listGenericJSXElement = new Array<JSX.Element>();

//var pagecounter: number = 0;

// --------------------------------------------------
const FlowEngine : React.FunctionComponent<FlowEngineProps> = (props) => {  
  /*
  const [listGenericJSXElement, setListGenericJSXElement] = useState<Array<JSX.Element>>(new Array<JSX.Element>() );
  const [currentPage, setCurrentPage] = useState<Page | undefined>(getPageByIndex(0));

  // JavaScript "array destructuring": [term1, term2, term3] is translated into 3 single variables "term1", "term2" and "term3"
  //const [invalid, setInvalid] = useState<boolea>(false);

  // -----------
  function handleSubmitNext (event: React.MouseEvent<HTMLElement>) {
    //check if it is already a page in the array if not it is the first    
    let currentPageName: string;
    
    if(listGenericJSXElement.length <= 0) {
      currentPageName = currentPage?.id as string;
    } else {
      currentPageName = currentPage?.nextResolver() as string;
      setCurrentPage(getPageByKey(currentPageName));
    }

    //
    listGenericJSXElement.push(
      <div key={pagecounter++} >
        <GenericPageComponent key={pagecounter++} pagename={currentPageName}></GenericPageComponent>
      </div>
    );

    setListGenericJSXElement([...listGenericJSXElement]);

    //console.log(listGenericJSXElement);
  }

  // -----------
  function handleSubmitPrev (event: React.MouseEvent<HTMLElement>) {
    listGenericJSXElement.pop();
    setListGenericJSXElement([...listGenericJSXElement]);
  } 
  */


  // retrieves the url parameter from react-router-dom routing in Body.tsx (ATTENTION: you can use useParams only when the Router is in one of your PARENT components !!!)
  const { page } = useParams<ParamTypes>();

  /*
  useEffect(() => {
      // on mount: load initial flow structure into redux store
      let flow = getFlow();  //
      const state: any = {
        flow: flow,
      }
      props.updateFlowInput(state);
    }
  });
  */

  //setFlowTarget(props.target);


  //
  return (
    <Grid container>
      <Grid item xs={3}>
        {/* <GenericTableOfContent pagename={page}></GenericTableOfContent> */}
        <GenericFlowOverview pagename={page}></GenericFlowOverview>
      </Grid>
      <Grid item xs={9}>
        <GenericPageComponent pagename={page}></GenericPageComponent>
        {/* listGenericJSXElement */}
      </Grid>
      {/*
      <Grid item xs={12}>
        <UploadFilesDragAndDrop/>
        <br/>
        <Button variant="outlined" color="primary" style={{"minWidth":"200px", "width": "100px", color: "white", float: "left"}} onClick={handleSubmitPrev}>Previous ...</Button>
        <Button variant="outlined" color="primary" style={{"minWidth":"200px", "width": "100px", color: "white", float: "right"}} onClick={handleSubmitNext}>Next ...</Button>
      </Grid>
      */}
    </Grid>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(FlowEngine);
